import React from "react";
import Tooltip from "@material-ui/core/Tooltip";

const HoverTooltip = ({
	placement = "top",
	arrow = true,
	enterDelay = 0,
	leaveDelay = 0,
	...rest
}) => (
	<Tooltip
		placement={placement}
		arrow={arrow}
		enterDelay={enterDelay}
		leaveDelay={leaveDelay}
		{...rest}
	/>
);

export default HoverTooltip;
